import React from 'react';
import { useTranslation } from 'react-i18next';
import { Youtube, Facebook, Video, Clock, AlertCircle, CheckCircle } from 'lucide-react';

function HistoryTab({ uploadHistory, formatDate, formatFileSize }) {
  const { t } = useTranslation();

  if (uploadHistory.length === 0) {
    return (
      <div className="bg-white rounded-xl shadow-sm p-6">
        <h2 className="text-2xl font-bold text-gray-800 mb-6">{t('app.history.title')}</h2>
        <div className="text-center py-12">
          <Clock className="mx-auto text-gray-400 mb-4" size={48} />
          <p className="text-gray-500">{t('app.history.emptyTitle')}</p>
          <p className="text-sm text-gray-400 mt-2">{t('app.history.emptyDescription')}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-xl shadow-sm p-6">
      <h2 className="text-2xl font-bold text-gray-800 mb-6">{t('app.history.title')}</h2>
      <div className="space-y-4">
        {uploadHistory.map((upload) => (
          <div key={upload.id} className="border border-gray-200 rounded-lg p-4">
            <div className="flex items-start justify-between mb-3">
              <div>
                <h3 className="font-semibold text-gray-800">{upload.title}</h3>
                <p className="text-sm text-gray-500">{upload.filename} • {formatFileSize(upload.size)}</p>
                <p className="text-xs text-gray-400 mt-1">{formatDate(upload.timestamp)}</p>
              </div>
            </div>
            <div className="flex flex-wrap gap-2">
              {upload.platforms.map((platform) => (
                <div
                  key={platform}
                  className={`flex items-center space-x-2 px-3 py-1 rounded-full text-sm ${
                    upload.results[platform] === 'success'
                      ? 'bg-green-100 text-green-700'
                      : 'bg-red-100 text-red-700'
                  }`}
                >
                  {platform === 'youtube' && <Youtube size={14} />}
                  {platform === 'facebook' && <Facebook size={14} />}
                  {platform === 'tiktok' && <Video size={14} />}
                  <span className="capitalize">{platform}</span>
                  {upload.results[platform] === 'success' ? (
                    <CheckCircle size={14} />
                  ) : (
                    <AlertCircle size={14} />
                  )}
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default HistoryTab;